import { UserId } from 'modules/management/users/types/users-interface'
import { SubAccountResourcesInterface } from '../types/sub-account-interface'

export const findResourceByUserId = (
  userId: UserId,
  resources?: SubAccountResourcesInterface[],
): SubAccountResourcesInterface | null => {
  if (!resources) return null

  return resources.find(({ user }) => user.id === userId) ?? null
}
